import { bannerById, unitById } from "@zend/content";
import type { BannerView } from "./types.js";

export function offerGuarantees(banner: BannerView) {
  const s = Math.max(1, banner.pity.hardPity - banner.pity.sinceS);
  const a = Math.min(s, Math.max(1, bannerById(banner.id).aGuaranteeEvery - banner.pity.sinceA));
  return { s, a };
}

/** Illustration uses actual pool members, including the real first standard reward. */
export function offerUnits(banner: BannerView): string[] {
  const opening = banner.id === "standard" && banner.pity.pulls === 0;
  const first = opening ? "unit.shieldwall_mk2" : banner.featuredUnitId ?? banner.pool.find(id => unitById(id).tier === "S") ?? banner.pool[0];
  return [...new Set([first, ...banner.pool.filter(id => unitById(id).tier === "S"), ...banner.pool])].filter((id): id is string => !!id && banner.pool.includes(id)).slice(0, 3);
}
